import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import '../../../../assets/stylesheets/ProfileSlide/ProfilePopUp.scss';

const Language =({}) => {
    const { t } = useTranslation();
    const countries = [
        {value: 'us', label: 'United States'}, 
        {value: 'fr', label: 'France'}, 
        {value: 'jp', label: 'Japan'}, 
        {value: 'ca', label: 'Canada'},
        {value: 'gr', label: 'Greece'}
    ]
    const [selectedCountry, selectCountry] = useState ({});

    return (
        <React.Fragment>
            <div className={`profileDialog profile-profile-country`}>
                <label>
                    <input type="text" className={'searchCountry'} />
                    <span className={'searchIcon'}></span>
                </label>
                <div className="dialogContent countryContent scrollable">
                    {
                        countries.map((country, index) => 
                        <div key={index} className={`countryTab ${country.value === selectedCountry.value ? 'selected' : ''}`} onClick={()=>selectCountry(country)}>
                            <span className={`countryFlag  ${country.value}`}></span>
                            <span className="countryName">{country.label}</span>
                        </div>)
                    }
                </div>
                <div className="dialogConfirmBox">
                    <button className={'primary'} disabled={Object.keys(selectedCountry).length === 0}>
                        {t('button.confirm')}
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Language;
